import React from 'react';
import type { IconProps } from '../types';

export const Bicmd = (props: IconProps) => (
  <svg
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 600 255.9"
    style={{ enableBackground: 'new 0 0 600 255.9' } as unknown}
    xmlSpace="preserve"
    data-icon="bicmd"
    width="72px"
    height="30px"
    {...props}
  >
    <g id="Layer_1">
      <g>
        <path
          style={{ fill: '#FFFFFF' }}
          d="M92,121.9c12.2,0.9,21.2,3.9,27.2,9.1c5.9,5.2,8.9,11.6,8.9,19.4c0,6.8-2,12.6-6,17.5
			c-4,4.9-9.1,8.1-15.4,9.6c-6.3,1.5-14.6,2.3-25.1,2.3H39.3v-3.6h4.1c4.6,0,7.8-0.6,9.5-1.7c1.8-1.2,2.9-3,3.4-5.4
			s0.7-8.2,0.7-17.1V99.5c0-8.7-0.3-14.3-0.8-16.9c-0.5-2.5-1.6-4.3-3.2-5.2c-1.6-1-5.1-1.4-10.6-1.4h-2.1v-3.6l17.7-0.5l20.1-0.6
			c29.4,0,44,8.4,44,25.3c0,7-2.5,12.6-7.6,16.8C109.7,117.6,102.1,120.4,92,121.9z M72.6,120.4c1.3,0.1,2.4,0.1,3.3,0.1
			c11.4,0,19.2-1.8,23.4-5.4c4.2-3.6,6.3-9.4,6.3-17.4c0-5.6-0.8-9.9-2.5-13c-1.6-3.1-4.1-5.4-7.4-7.1c-3.3-1.7-8.9-2.5-16.8-2.5
			c-2.1,0-4.2,0.1-6.3,0.2V120.4z M72.6,124.3v23.9c0,10.2,0.2,16.7,0.6,19.4c0.4,2.7,1.4,4.8,3,6.3c1.6,1.4,4.8,2.1,9.5,2.1
			c8.4,0,14.8-2.2,19-6.5c4.2-4.3,6.3-10.8,6.3-19.5c0-8.9-2.4-15.4-7.2-19.6c-4.8-4.2-13.2-6.3-25.2-6.3
			C76.7,124.1,74.7,124.2,72.6,124.3z"
        />
        <path
          style={{ fill: '#FFFFFF' }}
          d="M138.6,76v-3.6h49.1V76h-2.3c-5.3,0-8.7,0.4-10.4,1.3c-1.6,0.9-2.7,2.5-3.3,4.9c-0.6,2.4-0.8,8-0.8,16.9v52.7
			c0,8.4,0.2,14,0.6,16.6c0.4,2.6,1.5,4.6,3.2,5.8c1.7,1.3,5,1.9,9.9,1.9h3.2v3.6h-49.1v-3.6h3.2c4.6,0,7.8-0.6,9.5-1.7
			c1.8-1.2,2.9-3,3.4-5.4s0.7-8.2,0.7-17.1V99.1c0-8.6-0.2-14.1-0.7-16.5c-0.5-2.5-1.5-4.2-3.2-5.1c-1.6-1-5.2-1.4-10.6-1.4H138.6z"
        />
        <path
          style={{ fill: '#FFFFFF' }}
          d="M296,146.4c0,0,1.4,0,3.4,0c-3,16.8-18.8,35.3-48.2,35.3c-15.5,0-28.2-4.9-38-14.7
			c-9.8-9.8-14.8-22.8-14.8-39c0-10.6,2.3-20.6,6.8-30c4.5-9.4,10.9-16.3,19-20.9c8.1-4.5,17.1-6.8,26.8-6.8c8,0,15.3,1.7,21.8,4.9
			c6.5,3.3,11.4,7,14.6,11c2.3-4.5,3.6-9.1,4.1-13.9h3.5l1,40.7h-3.4c-2.4-14.5-7.2-24.5-14.5-30.2c-7.3-5.6-15.6-8.5-24.7-8.5
			c-11.2,0-20.2,4.6-26.8,13.7c-6.6,9.1-9.9,22.2-9.9,39.2c0,16.1,3.6,28.4,10.8,37c7.2,8.6,16.2,12.9,27,12.9
			C281.5,177.2,294.6,156,296,146.4z"
        />
      </g>
      <path
        style={{ fill: '#2073FF' }}
        d="M533,211.6H341c-11.8,0-21.4-9.6-21.4-21.4V61.9c0-11.8,9.6-21.4,21.4-21.4h192c11.8,0,21.4,9.6,21.4,21.4
		v128.2C554.4,201.9,544.8,211.6,533,211.6z"
      />
      <path
        style={{ fill: '#FFFFFF' }}
        d="M467.5,83h-17.3v0h-7.8l-36.3,38.4L371.3,83h-9.2v86.1h16v-55.5l28,29.7l42.6-45.1h17.1
		c19.1,0,29.6,11.3,29.6,28c0,16.7-10.6,27.8-29.6,27.8h-15.6v-35.8l-16,16.9v34.1h33.3c26.4,0.4,45-18.3,44.7-43.1
		C512.5,101.3,494,82.6,467.5,83z"
      />
    </g>
    <g
      id="Spacing"
      style={{ display: 'none' }}
    >
      <rect
        style={{
          display: 'inline',
          fill: ' none',
          stroke: '#F6ADCC',
          strokeWidth: 0.5,
          strokeLinecap: 'round',
          strokeMiterlimit: 10,
        }}
        width="600"
        height="255.9"
      />
      <line
        style={{
          display: 'inline',
          fill: ' none',
          stroke: '#F6ADCC',
          strokeLinecap: 'round',
          strokeMiterlimit: 10,
          strokeDasharray: 4.8,
        }}
        x1="557.5"
        y1="84.9"
        x2="322.8"
        y2="84.9"
      />
      <line
        style={{
          display: 'inline',
          fill: ' none',
          stroke: '#F6ADCC',
          strokeLinecap: 'round',
          strokeMiterlimit: 10,
          strokeDasharray: 4.8,
        }}
        x1="557.5"
        y1="171"
        x2="42.5"
        y2="171"
      />
      <line
        style={{
          display: 'inline',
          fill: ' none',
          stroke: '#F6ADCC',
          strokeLinecap: 'round',
          strokeMiterlimit: 10,
          strokeDasharray: 4.8,
        }}
        x1="536.3"
        y1="192.3"
        x2="42.5"
        y2="192.3"
      />
      <line
        style={{
          display: 'inline',
          fill: ' none',
          stroke: '#F6ADCC',
          strokeLinecap: 'round',
          strokeMiterlimit: 10,
          strokeDasharray: 4.8,
        }}
        x1="365.2"
        y1="181.6"
        x2="42.5"
        y2="181.6"
      />
      <line
        style={{
          display: 'inline',
          fill: ' none',
          stroke: '#F6ADCC',
          strokeLinecap: 'round',
          strokeMiterlimit: 10,
          strokeDasharray: 4.8,
        }}
        x1="365.2"
        y1="202.9"
        x2="42.5"
        y2="202.9"
      />
      <line
        style={{
          display: 'inline',
          fill: ' none',
          stroke: '#F6ADCC',
          strokeLinecap: 'round',
          strokeMiterlimit: 10,
          strokeDasharray: 4.8,
        }}
        x1="365.2"
        y1="42.5"
        x2="365.2"
        y2="213.5"
      />
      <line
        style={{
          display: 'inline',
          fill: ' none',
          stroke: '#F6ADCC',
          strokeLinecap: 'round',
          strokeMiterlimit: 10,
          strokeDasharray: 4.8,
        }}
        x1="515.1"
        y1="42.5"
        x2="515.1"
        y2="213.5"
      />
      <g style={{ display: 'inline' }}>
        <path
          style={{ fill: '#F6ADCC' }}
          d="M536.3,43c11.4,0,20.7,9.3,20.7,20.7s-9.3,20.7-20.7,20.7s-20.7-9.3-20.7-20.7S524.9,43,536.3,43 M536.3,42.5
			c-11.7,0-21.2,9.5-21.2,21.2s9.5,21.2,21.2,21.2s21.2-9.5,21.2-21.2S548,42.5,536.3,42.5L536.3,42.5z"
        />
      </g>
      <circle
        style={{ display: 'inline', fill: '#F8C1D9' }}
        cx="578.8"
        cy="21.2"
        r="21.2"
      />
      <circle
        style={{ display: 'inline', fill: '#F8C1D9' }}
        cx="578.8"
        cy="234.7"
        r="21.2"
      />
      <circle
        style={{ display: 'inline', fill: '#F8C1D9' }}
        cx="21.2"
        cy="21.2"
        r="21.2"
      />
      <circle
        style={{ display: 'inline', fill: '#F8C1D9' }}
        cx="21.2"
        cy="234.7"
        r="21.2"
      />
      <g style={{ display: 'inline' }}>
        <path
          style={{ fill: '#F6ADCC' }}
          d="M536.3,171.5c11.4,0,20.7,9.3,20.7,20.7s-9.3,20.7-20.7,20.7s-20.7-9.3-20.7-20.7S524.9,171.5,536.3,171.5
			 M536.3,171c-11.7,0-21.2,9.5-21.2,21.2s9.5,21.2,21.2,21.2s21.2-9.5,21.2-21.2S548,171,536.3,171L536.3,171z"
        />
      </g>
      <line
        style={{
          display: 'inline',
          fill: ' none',
          stroke: '#F6ADCC',
          strokeLinecap: 'round',
          strokeMiterlimit: 10,
          strokeDasharray: 4.8,
        }}
        x1="536.3"
        y1="63.7"
        x2="42.5"
        y2="63.7"
      />
      <line
        style={{
          display: 'inline',
          fill: ' none',
          stroke: '#F6ADCC',
          strokeLinecap: 'round',
          strokeMiterlimit: 10,
          strokeDasharray: 4.8,
        }}
        x1="301.5"
        y1="42.5"
        x2="301.5"
        y2="213.5"
      />
      <line
        style={{
          display: 'inline',
          fill: ' none',
          stroke: '#F6ADCC',
          strokeLinecap: 'round',
          strokeMiterlimit: 10,
          strokeDasharray: 4.8,
        }}
        x1="312.1"
        y1="42.5"
        x2="312.1"
        y2="213.5"
      />
      <line
        style={{
          display: 'inline',
          fill: ' none',
          stroke: '#F6ADCC',
          strokeLinecap: 'round',
          strokeMiterlimit: 10,
          strokeDasharray: 4.8,
        }}
        x1="190.9"
        y1="42.5"
        x2="190.9"
        y2="213.5"
      />
      <line
        style={{
          display: 'inline',
          fill: ' none',
          stroke: '#F6ADCC',
          strokeLinecap: 'round',
          strokeMiterlimit: 10,
          strokeDasharray: 4.8,
        }}
        x1="201.5"
        y1="42.5"
        x2="201.5"
        y2="213.5"
      />
      <line
        style={{
          display: 'inline',
          fill: ' none',
          stroke: '#F6ADCC',
          strokeLinecap: 'round',
          strokeMiterlimit: 10,
          strokeDasharray: 4.8,
        }}
        x1="131.1"
        y1="42.5"
        x2="131.1"
        y2="213.5"
      />
      <line
        style={{
          display: 'inline',
          fill: ' none',
          stroke: '#F6ADCC',
          strokeLinecap: 'round',
          strokeMiterlimit: 10,
          strokeDasharray: 4.8,
        }}
        x1="141.8"
        y1="42.5"
        x2="141.8"
        y2="213.5"
      />
      <line
        style={{
          display: 'inline',
          fill: ' none',
          stroke: '#F49AC1',
          strokeLinecap: 'round',
          strokeMiterlimit: 10,
          strokeDasharray: 4.8,
        }}
        x1="42.5"
        y1="0"
        x2="42.5"
        y2="255.9"
      />
      <line
        style={{
          display: 'inline',
          fill: ' none',
          stroke: '#F6ADCC',
          strokeLinecap: 'round',
          strokeMiterlimit: 10,
          strokeDasharray: 4.8,
        }}
        x1="322.8"
        y1="42.5"
        x2="322.8"
        y2="213.5"
      />
      <line
        style={{
          display: 'inline',
          fill: ' none',
          stroke: '#F49AC1',
          strokeLinecap: 'round',
          strokeMiterlimit: 10,
          strokeDasharray: 4.8,
        }}
        x1="557.5"
        y1="0"
        x2="557.5"
        y2="255.9"
      />
      <line
        style={{
          display: 'inline',
          fill: ' none',
          stroke: '#F6ADCC',
          strokeLinecap: 'round',
          strokeMiterlimit: 10,
          strokeDasharray: 4.8,
        }}
        x1="600"
        y1="42.5"
        x2="0"
        y2="42.5"
      />
      <line
        style={{
          display: 'inline',
          fill: ' none',
          stroke: '#F6ADCC',
          strokeLinecap: 'round',
          strokeMiterlimit: 10,
          strokeDasharray: 4.8,
        }}
        x1="600"
        y1="213.5"
        x2="0"
        y2="213.5"
      />
      <line
        style={{
          display: 'inline',
          fill: ' none',
          stroke: '#F6ADCC',
          strokeLinecap: 'round',
          strokeMiterlimit: 10,
          strokeDasharray: 4.8,
        }}
        x1="365.2"
        y1="191.8"
        x2="486.2"
        y2="63.7"
      />
      <line
        style={{
          display: 'inline',
          fill: ' none',
          stroke: '#F6ADCC',
          strokeLinecap: 'round',
          strokeMiterlimit: 10,
          strokeDasharray: 4.8,
        }}
        x1="365.2"
        y1="213.5"
        x2="505.5"
        y2="63.7"
      />
      <rect
        x="721.1"
        style={{
          display: 'inline',
          fill: ' none',
          stroke: '#F6ADCC',
          strokeWidth: 0.5,
          strokeLinecap: 'round',
          strokeMiterlimit: 10,
        }}
        width="600"
        height="255.9"
      />
      <line
        style={{
          display: 'inline',
          fill: ' none',
          stroke: '#F6ADCC',
          strokeLinecap: 'round',
          strokeMiterlimit: 10,
          strokeDasharray: 4.8,
        }}
        x1="1278.7"
        y1="84.9"
        x2="1043.9"
        y2="84.9"
      />
      <line
        style={{
          display: 'inline',
          fill: ' none',
          stroke: '#F6ADCC',
          strokeLinecap: 'round',
          strokeMiterlimit: 10,
          strokeDasharray: 4.8,
        }}
        x1="1278.7"
        y1="171"
        x2="1043.9"
        y2="171"
      />
      <line
        style={{
          display: 'inline',
          fill: ' none',
          stroke: '#F6ADCC',
          strokeLinecap: 'round',
          strokeMiterlimit: 10,
          strokeDasharray: 4.8,
        }}
        x1="1257.4"
        y1="192.3"
        x2="763.6"
        y2="192.3"
      />
      <line
        style={{
          display: 'inline',
          fill: ' none',
          stroke: '#F6ADCC',
          strokeLinecap: 'round',
          strokeMiterlimit: 10,
          strokeDasharray: 4.8,
        }}
        x1="1086.3"
        y1="181.6"
        x2="763.6"
        y2="181.6"
      />
      <line
        style={{
          display: 'inline',
          fill: ' none',
          stroke: '#F6ADCC',
          strokeLinecap: 'round',
          strokeMiterlimit: 10,
          strokeDasharray: 4.8,
        }}
        x1="1086.3"
        y1="74.3"
        x2="763.6"
        y2="74.3"
      />
      <line
        style={{
          display: 'inline',
          fill: ' none',
          stroke: '#F6ADCC',
          strokeLinecap: 'round',
          strokeMiterlimit: 10,
          strokeDasharray: 4.8,
        }}
        x1="1086.3"
        y1="42.5"
        x2="1086.3"
        y2="213.5"
      />
      <line
        style={{
          display: 'inline',
          fill: ' none',
          stroke: '#F6ADCC',
          strokeLinecap: 'round',
          strokeMiterlimit: 10,
          strokeDasharray: 4.8,
        }}
        x1="1236.2"
        y1="42.5"
        x2="1236.2"
        y2="213.5"
      />
      <g style={{ display: 'inline' }}>
        <path
          style={{ fill: '#F6ADCC' }}
          d="M1257.4,43c11.4,0,20.7,9.3,20.7,20.7s-9.3,20.7-20.7,20.7s-20.7-9.3-20.7-20.7S1246,43,1257.4,43
			 M1257.4,42.5c-11.7,0-21.2,9.5-21.2,21.2s9.5,21.2,21.2,21.2s21.2-9.5,21.2-21.2S1269.2,42.5,1257.4,42.5L1257.4,42.5z"
        />
      </g>
      <circle
        style={{ display: 'inline', fill: '#F8C1D9' }}
        cx="1299.9"
        cy="21.2"
        r="21.2"
      />
      <circle
        style={{ display: 'inline', fill: '#F8C1D9' }}
        cx="1299.9"
        cy="234.7"
        r="21.2"
      />
      <circle
        style={{ display: 'inline', fill: '#F8C1D9' }}
        cx="742.3"
        cy="21.2"
        r="21.2"
      />
      <circle
        style={{ display: 'inline', fill: '#F8C1D9' }}
        cx="742.3"
        cy="234.7"
        r="21.2"
      />
      <g style={{ display: 'inline' }}>
        <path
          style={{ fill: '#F6ADCC' }}
          d="M1257.4,171.5c11.4,0,20.7,9.3,20.7,20.7s-9.3,20.7-20.7,20.7s-20.7-9.3-20.7-20.7S1246,171.5,1257.4,171.5
			 M1257.4,171c-11.7,0-21.2,9.5-21.2,21.2s9.5,21.2,21.2,21.2s21.2-9.5,21.2-21.2S1269.2,171,1257.4,171L1257.4,171z"
        />
      </g>
      <line
        style={{
          display: 'inline',
          fill: ' none',
          stroke: '#F6ADCC',
          strokeLinecap: 'round',
          strokeMiterlimit: 10,
          strokeDasharray: 4.8,
        }}
        x1="1257.4"
        y1="63.7"
        x2="763.6"
        y2="63.7"
      />
      <line
        style={{
          display: 'inline',
          fill: ' none',
          stroke: '#F6ADCC',
          strokeLinecap: 'round',
          strokeMiterlimit: 10,
          strokeDasharray: 4.8,
        }}
        x1="1022.6"
        y1="42.5"
        x2="1022.6"
        y2="213.5"
      />
      <line
        style={{
          display: 'inline',
          fill: ' none',
          stroke: '#F6ADCC',
          strokeLinecap: 'round',
          strokeMiterlimit: 10,
          strokeDasharray: 4.8,
        }}
        x1="1033.3"
        y1="42.5"
        x2="1033.3"
        y2="213.5"
      />
      <line
        style={{
          display: 'inline',
          fill: ' none',
          stroke: '#F6ADCC',
          strokeLinecap: 'round',
          strokeMiterlimit: 10,
          strokeDasharray: 4.8,
        }}
        x1="912"
        y1="42.5"
        x2="912"
        y2="213.5"
      />
      <line
        style={{
          display: 'inline',
          fill: ' none',
          stroke: '#F6ADCC',
          strokeLinecap: 'round',
          strokeMiterlimit: 10,
          strokeDasharray: 4.8,
        }}
        x1="922.6"
        y1="42.5"
        x2="922.6"
        y2="213.5"
      />
      <line
        style={{
          display: 'inline',
          fill: ' none',
          stroke: '#F6ADCC',
          strokeLinecap: 'round',
          strokeMiterlimit: 10,
          strokeDasharray: 4.8,
        }}
        x1="852.3"
        y1="42.5"
        x2="852.3"
        y2="213.5"
      />
      <line
        style={{
          display: 'inline',
          fill: ' none',
          stroke: '#F6ADCC',
          strokeLinecap: 'round',
          strokeMiterlimit: 10,
          strokeDasharray: 4.8,
        }}
        x1="862.9"
        y1="42.5"
        x2="862.9"
        y2="213.5"
      />
      <line
        style={{
          display: 'inline',
          fill: ' none',
          stroke: '#F6ADCC',
          strokeLinecap: 'round',
          strokeMiterlimit: 10,
          strokeDasharray: 4.8,
        }}
        x1="763.6"
        y1="0"
        x2="763.6"
        y2="255.9"
      />
      <line
        style={{
          display: 'inline',
          fill: ' none',
          stroke: '#F6ADCC',
          strokeLinecap: 'round',
          strokeMiterlimit: 10,
          strokeDasharray: 4.8,
        }}
        x1="1043.9"
        y1="42.5"
        x2="1043.9"
        y2="213.5"
      />
      <line
        style={{
          display: 'inline',
          fill: ' none',
          stroke: '#F6ADCC',
          strokeLinecap: 'round',
          strokeMiterlimit: 10,
          strokeDasharray: 4.8,
        }}
        x1="1278.7"
        y1="0"
        x2="1278.7"
        y2="255.9"
      />
      <line
        style={{
          display: 'inline',
          fill: ' none',
          stroke: '#F6ADCC',
          strokeLinecap: 'round',
          strokeMiterlimit: 10,
          strokeDasharray: 4.8,
        }}
        x1="1321.1"
        y1="42.5"
        x2="721.1"
        y2="42.5"
      />
      <line
        style={{
          display: 'inline',
          fill: ' none',
          stroke: '#F6ADCC',
          strokeLinecap: 'round',
          strokeMiterlimit: 10,
          strokeDasharray: 4.8,
        }}
        x1="1321.1"
        y1="213.5"
        x2="721.1"
        y2="213.5"
      />
      <line
        style={{
          display: 'inline',
          fill: ' none',
          stroke: '#F6ADCC',
          strokeLinecap: 'round',
          strokeMiterlimit: 10,
          strokeDasharray: 4.8,
        }}
        x1="1086.3"
        y1="191.8"
        x2="1207.3"
        y2="63.7"
      />
      <line
        style={{
          display: 'inline',
          fill: ' none',
          stroke: '#F6ADCC',
          strokeLinecap: 'round',
          strokeMiterlimit: 10,
          strokeDasharray: 4.8,
        }}
        x1="1086.3"
        y1="213.5"
        x2="1226.6"
        y2="63.7"
      />
    </g>
  </svg>
);

export default Bicmd;
